import React from 'react';

import { Button, DynamicIconWrapper, GridContainer, Icons, Tooltip } from '@components/common';

import styles from '@components/common/Actions/Actions.module.scss';

interface IAdditionalActionsOranTableProps {
	importHandler: () => void;
	clearHandler: () => void;
	onRebuild?: () => void;
	isClear?: boolean;
	isRebuild?: boolean;
}

const AdditionalActionsOranTable = ({
	importHandler,
	clearHandler,
	onRebuild,
	isClear,
	isRebuild,
}: IAdditionalActionsOranTableProps) => (
	<GridContainer
		gap='5px'
		justifyItems='center'
		style={{ alignItems: 'center', maxWidth: 'fit-content' }}
	>
		{isRebuild && (
			<Button
				onClick={onRebuild}
				secondary
			>
				Rebuild
			</Button>
		)}
		<Tooltip content='Upload YANG files'>
			<div
				className={styles.icon}
				data-testid='edit-date'
				onClick={importHandler}
			>
				<DynamicIconWrapper icon={Icons.import} />
			</div>
		</Tooltip>
		{isClear && (
			<Tooltip content='Clear folder'>
				<div
					className={styles.icon}
					data-testid='clear-date'
					onClick={clearHandler}
				>
					<DynamicIconWrapper icon={Icons.clearFilesIcon} />
				</div>
			</Tooltip>
		)}
	</GridContainer>
);

export default AdditionalActionsOranTable;
